import React from 'react';

const Reset = () => {
  return (
    <svg width="24" height="24" className="path" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.1732 3.54327L9.8303 6.28006C9.53829 6.5517 9.57903 7.02708 9.9118 7.24439L12.6757 9.54655"
        stroke="#787F88"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5093 6.68083C11.0662 6.53822 11.6502 6.45673 12.2478 6.45673C15.9965 6.45673 19.0389 9.49911 19.0389 13.2478C19.0389 16.9964 15.9965 20.0388 12.2478 20.0388C8.49917 20.0388 5.45679 16.9964 5.45679 13.2478"
        stroke="#787F88"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Reset;
